export default {
  THIS_MEDIA: 'media',
  ALL_MEDIA: 'all-media',
};
